export const cyNameIntroStep = 'introPage';
export const cyNameDataStep = 'ContactDetailsStep';
